import React, { useContext } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { I18nContext } from '../../context/translations/TranslationsContext.context';

interface WelcomeV2ModalProps {
	isOpen: boolean;
	onClose: () => void;
}

const POINTS = [
	{
		emoji: '👋',
		titleKey: 'welcome.v2.point1.title',
		descKey: 'welcome.v2.point1.desc',
		bg: 'bg-sky-50'
	},
	{
		emoji: '🎨',
		titleKey: 'welcome.v2.point2.title',
		descKey: 'welcome.v2.point2.desc',
		bg: 'bg-emerald-50'
	},
	{
		emoji: '🔑',
		titleKey: 'welcome.v2.point3.title',
		descKey: 'welcome.v2.point3.desc',
		bg: 'bg-orange-50'
	},
	{
		emoji: '🤖',
		titleKey: 'welcome.v2.point4.title',
		descKey: 'welcome.v2.point4.desc',
		bg: 'bg-violet-50',
		linkUrl: 'https://support.arcadigital.app/'
	}
] as const;

const WelcomeV2Modal: React.FC<WelcomeV2ModalProps> = ({ isOpen, onClose }) => {
	const {
		state: { translate }
	} = useContext(I18nContext);

	return (
		<Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
			<DialogContent className="sm:max-w-2xl">
				<DialogHeader>
					<DialogTitle className="text-center text-xl font-bold leading-tight">
						{translate('welcome.v2.title')}
					</DialogTitle>
				</DialogHeader>

				<div className="space-y-3 py-2">
					{POINTS.map((point) => (
						<div
							key={point.titleKey}
							className={`flex items-start gap-3 rounded-xl ${point.bg} p-4`}
						>
							<span className="text-2xl shrink-0" role="img">
								{point.emoji}
							</span>
							<div>
								<p className="font-semibold text-sm">
									{translate(point.titleKey)}
									{'linkUrl' in point && (
										<a
											href={point.linkUrl}
											target="_blank"
											rel="noopener noreferrer"
											className="ml-1 text-primary underline hover:text-primary/80"
										>
											{translate('welcome.v2.point4.linkText')}
										</a>
									)}
								</p>
								<p className="text-xs text-muted-foreground mt-0.5">{translate(point.descKey)}</p>
							</div>
						</div>
					))}
				</div>

				<Button onClick={onClose} className="w-full btn-arca-primary py-6 text-base font-semibold">
					{translate('welcome.v2.button')}
				</Button>
			</DialogContent>
		</Dialog>
	);
};

export default WelcomeV2Modal;
